import * as FlagActionTypes from '../actions/flagged';
import initialState from '../reducers/initialState';

export default (state=initialState.flags, action)=>{
    const { payload,type }=action;

    switch(type){
        case FlagActionTypes.CREATE_COUNTRY_FLAG:
        case FlagActionTypes.CREATE_COUNTRY_FLAG_PENDING:
            return { ...state }
        case FlagActionTypes.CREATE_COUNTRY_FLAG_REJECTED:
            return { ...state, error:true, errorMessage:payload.data }
        case FlagActionTypes.CREATE_COUNTRY_FLAG_FULFILLED:
            let flaggedCountry=payload.data;
            return Object.assign({}, state,{
                flagged_countries:[
                    flaggedCountry,
                    ...state.flagged_countries
                ],
                createCountryFlagSuccess:true
            });

        case FlagActionTypes.CREATE_PORTS_FLAG:
        case FlagActionTypes.CREATE_PORTS_FLAG_PENDING:
            return { ...state }
        case FlagActionTypes.CREATE_PORTS_FLAG_REJECTED:
            return { ...state ,error:true, errorMessage:payload.data }
        case FlagActionTypes.CREATE_PORTS_FLAG_FULFILLED:
            let flaggedPort=payload.data;
            return Object.assign({}, state,{
                flagged_ports:[
                    flaggedPort,
                    ...state.flagged_ports
                ],
                createPortFlagSuccess:true
            })

        case FlagActionTypes.LIST_COUNTRY_FLAGS:
        case FlagActionTypes.LIST_COUNTRY_FLAGS_PENDING:
            return { ...state, countryFlagsLoading:true }
        case FlagActionTypes.LIST_COUNTRY_FLAGS_REJECTED:
            return { ...state, countryFlagsLoading:false, error: payload.error, errorMessage: payload.response.data }
        case FlagActionTypes.LIST_COUNTRY_FLAGS_FULFILLED:
            return { ...state, countryFlagsLoading:false , flagged_countries: payload.data }

        case FlagActionTypes.LIST_PORT_FLAGS:
        case FlagActionTypes.LIST_PORT_FLAGS_PENDING:
            return { ...state, portFlagLoading: true }
        case FlagActionTypes.LIST_PORT_FLAGS_REJECTED:
            return { ...state, portFlagLoading:false, error: payload.error }
        case FlagActionTypes.LIST_PORT_FLAGS_FULFILLED:
            return { ...state, portFlagLoading:false, flagged_ports:payload.data }
        

        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/flagged.js